import SettingsTemplate from '@/components/services/settings/template'

export default function(h, options) {
  return h(SettingsTemplate(options))
}
